import { styled } from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: center;
  border-bottom: 2px solid white;
`